import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { ToastContainer } from "./utils/toast";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import AxiosConfigurations from "./components/AxiosConfigurations";
import PrivateRoute from "./components/login/PrivateRoute";
import GuestRoute from "./components/login/GuestRoute";
import towneRoutes from "./routes/towne.routes";
import townePublicRoutes from "./routes/towne.public.routes";


import { theme1Id } from "./utils/variables";
import CreateStore from "./pages/CreateStore";

// ✅ Import overlay manager
import StoreLocationOverlayManager from "./components/StoreLocationOverlayManager";
import ScrollToTop from "./components/scroll/ScrollToTop";

const Layout = lazy(() => import("./layout/Layout"));
const CustomizeTheme1 = lazy(() => import("./pages/customizeStore/theme1/Theme1"));
const TikTokUpdate = lazy(()=> import("./pages/TikTokUpdate"));
const MetaAuthorization = lazy(()=> import("./pages/MetaAuthorization"));
const CloverAuth = lazy(()=> import("./pages/CloverAuth"));
const ShopifyAuth = lazy(()=> import("./pages/ShopifyAuth"));
const GoogleAuthRedirect = lazy(()=> import("./pages/GoogleAuthRedirect"));
const BigCommerceAuth = lazy(()=> import("./pages/BigCommerceAuth"));
const IntegrationAuth = lazy(() => import("./pages/IntegrationAuth"));

const queryClient = new QueryClient();

const App = () => {
  const getLayoutRoutes = () => {
    const array = [];
    towneRoutes.map((route) => array.push(route.path));
    return array;
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <Router>
        <ScrollToTop />
        <AccessibleNavigationAnnouncer />
        <AxiosConfigurations />
        {/* ✅ Overlay will only appear in private (logged-in) routes */}
        
        <Switch>
          {/* Public Routes */}
          {townePublicRoutes?.map((route, i) => (
            <GuestRoute key={i} exact path={`${route.path}`}>
              <route.component />
            </GuestRoute>
          ))}

          {/* Integration routes without login check */}
          {/* <Route path="/integrations/google/auth" component={GoogleAuthRedirect} />
          <Route path="/integrations/tiktok/authorization-code" component={TikTokUpdate} />
          <Route path="/integrations/meta/authorization" component={MetaAuthorization} />
          <Route path="/integrations/clover/auth" component={CloverAuth} />
          <Route path="/integrations/shopify/auth" component={ShopifyAuth} />
          <Route path="/integrations/bigcommerce/auth" component={BigCommerceAuth} /> */}

          <Route path="/integrations/:provider/:action" component={IntegrationAuth} />


          {/* Private Routes */}
          <PrivateRoute>
            
            <StoreLocationOverlayManager />
            <Route path={getLayoutRoutes()} component={Layout} />
            <Route path={`/customize-store/${theme1Id}`} component={CustomizeTheme1} />
            <Route path="/edit-store" component={CreateStore} />
          </PrivateRoute>

          <Redirect exact from="/" to="/login" />
        </Switch>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
